<template>
  <Collapse class="l-block" ref="collapse">
    <template slot="title">
      <div class="flex">
        <div class="l-block__header">
          <TitleSub level="h3">
            <span class="title"><slot></slot></span>
            <div class="c-Percentage">
              {{ count }}
              <span>/ {{ total }}</span>
            </div>
            <p class="c-toggle"></p>
          </TitleSub>
        </div>
      </div>
    </template>
    <template slot="content">
      <FormCheckedTask
        v-if="hasError && hasTaskForm"
        :checked="params.checked"
        :project="project"
        type="seoCheckUp"
        @submit="uncheckItem"
      />
      <table class="c-table">
        <thead>
          <tr>
            <th v-if="hasTaskForm" width="29" @click.prevent="clickCheckAll">
              <Checkbox
                v-if="items.length && hasError"
                :checked="params.checkedAll"
                :id="category + '_all'"
                :name="category + '_all'"
                ref="checkbox"
                @change="changeCheckAll"
              />
            </th>
            <th width="240">チェック項目</th>
            <th>判定説明・内容・アドバイス</th>
            <ThSort
              v-model="params.sort"
              name="score"
              orderby="desc"
              type="number"
              width="100"
            >
              優先度
            </ThSort>
            <ThSort
              v-model="params.sort"
              name="hasError"
              orderby="desc"
              type="number"
              width="75"
            >
              判定
            </ThSort>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!items.length">
            <td class="l-p-0" :colspan="colspan">
              <Error variant="inline">
                <template slot="title">
                  データがありません。
                </template>
              </Error>
            </td>
          </tr>
          <template v-else>
            <ListItemIssue
              v-for="item in sortedItems"
              v-model="params.checked"
              :key="item.id"
              :item="item"
              :hasTaskForm="hasTaskForm"
            />
          </template>
        </tbody>
      </table>
      <FormCheckedTask
        v-if="hasError && hasTaskForm"
        :checked="params.checked"
        :project="project"
        type="seoCheckUp"
        @submit="uncheckItem"
      />
    </template>
  </Collapse>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import Collapse from '@/components/Collapse';
import Error from '@/components/Error';
import FormCheckedTask from '@/components/taskList/FormCheckedTask';
import ListItemIssue from '@/components/seo/ListItemIssue';
import ThSort from '@/components/ThSort';
import TitleSub from '@/components/TitleSub';
import utils from '@/utils';

export default {
  props: {
    category: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    hasTaskForm: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Checkbox,
    Collapse,
    Error,
    FormCheckedTask,
    ListItemIssue,
    ThSort,
    TitleSub
  },
  data() {
    return {
      params: {
        checked: [],
        checkedAll: false,
        sort: {
          name: 'hasError',
          orderby: 'desc',
          type: 'number'
        }
      }
    };
  },
  computed: {
    colspan() {
      return this.hasTaskForm ? 5 : 4;
    },
    count() {
      return this.total - this.errorItems.length;
    },
    errorItems() {
      return this.items.reduce((acc, cur) => {
        if (cur.hasError) {
          acc.push(cur);
        }
        return acc;
      }, []);
    },
    notificationsHeight() {
      return this.$store.state.view.size.notificationsHeight;
    },
    sortedItems() {
      let items = this.items.slice();
      return utils.sort(
        items,
        this.params.sort.type,
        this.params.sort.orderby,
        this.params.sort.name
      );
    },
    total() {
      return this.items.length;
    },
    hasError() {
      return this.errorItems.length ? true : false;
    }
  },
  watch: {
    'params.checked': {
      handler(value) {
        if (!value.length) {
          this.params.checkedAll = false;
        }
      }
    }
  },
  methods: {
    open() {
      this.$refs['collapse'].open();
    },
    clickCheckAll() {
      if (!this.$refs.checkbox) {
        return;
      }
      this.$refs.checkbox.change();
    },
    changeCheckAll(checked) {
      this.params.checkedAll = checked;
      if (checked) {
        this.checkAll();
      } else {
        this.uncheckAll();
      }
    },
    checkAll() {
      this.params.checked = this.errorItems.slice();
    },
    uncheckAll() {
      this.params.checked = [];
    },
    uncheckItem(item) {
      const checkedIndex = this.params.checked.indexOf(item);
      if (checkedIndex !== -1) {
        this.params.checked.splice(checkedIndex, 1);
      }
    }
  }
};
</script>
